export default __webpack_public_path__ + "static/media/About-2.37dcd707.jpg";